import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './Modals.scss';

function ModalButtonSpacer() {
    return <span className={styles['modal-button-spacer']} />
}

ModalButtonSpacer.displayName = displayName('Modals/ModalButtonSpacer');

export default ModalButtonSpacer;
